import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import NotFound from '@/packages/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  }, {
    path: '/index.html',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页'
    },
    component: Home
  }, {
    path: '/about',
    name: 'about',
    meta: {
      title: '关于甲申'
    },
    redirect: '/about/profile',
    component: () => import('../views/about/About.vue'),
    children: [{
      path: 'profile',
      meta: {
        title: '公司简介'
      },
      component: () => import('../views/about/components/Profile.vue')
    }, {
      path: 'culture',
      meta: {
        title: '企业文化'
      },
      component: () => import('../views/about/components/Culture.vue')
    }, {
      path: 'license',
      meta: {
        title: '企业资质'
      },
      component: () => import('../views/about/components/License.vue')
    }, {
      path: 'scope',
      meta: {
        title: '经营范围'
      },
      component: () => import('../views/about/components/Scope.vue')
    }, {
      path: 'branch',
      meta: {
        title: '服务网点'
      },
      component: () => import('../views/about/components/Branch.vue')
    }]
  }, {
    path: '/trends',
    name: 'trends',
    meta: {
      title: '信息动态'
    },
    redirect: '/trends/industry',
    component: () => import('../views/trends/Trends.vue'),
    children: [{
      path: 'industry',
      meta: {
        title: '行业动态'
      },
      component: () => import('../views/trends/components/Industry.vue')
    }, {
      path: 'company',
      meta: {
        title: '企业动态'
      },
      component: () => import('../views/trends/components/Company.vue')
    }]
  }, {
    path: '/project',
    name: 'project',
    meta: {
      title: '服务项目'
    },
    redirect: '/project/express',
    component: () => import('../views/project/Project.vue'),
    children: [{
      path: 'express',
      meta: {
        title: '速递业务'
      },
      component: () => import('../views/project/components/Express.vue')
    }, {
      path: 'cross-border',
      meta: {
        title: '跨境电商'
      },
      component: () => import('../views/project/components/CrossBorder.vue')
    }, {
      path: 'air-freight',
      meta: {
        title: '空运业务'
      },
      component: () => import('../views/project/components/AirFreight.vue')
    }, {
      path: 'shipping',
      meta: {
        title: '海运业务'
      },
      component: () => import('../views/project/components/Shipping.vue')
    }, {
      path: 'internal-trade',
      meta: {
        title: '内贸运输'
      },
      component: () => import('../views/project/components/InternalTrade.vue')
    }]
  }, /* {
    path: '/search',
    name: 'search',
    meta: {
      title: '综合查询'
    },
    component: () => import('../views/search/Search.vue')
  }, */ {
    path: '/recruitment',
    name: 'recruitment',
    meta: {
      title: '人才招聘'
    },
    component: () => import('../views/recruitment/Recruitment.vue'),
    redirect: '/recruitment/policy',
    children: [{
      path: 'policy',
      meta: {
        title: '人才理念'
      },
      component: () => import('../views/recruitment/components/Policy.vue')
    }, {
      path: 'join',
      meta: {
        title: '招聘信息'
      },
      component: () => import('../views/recruitment/components/Join.vue')
    }]
  }, {
    path: '/contact',
    name: 'contact',
    meta: {
      title: '联系我们'
    },
    component: () => import('../views/contact/Contact.vue')
  }, {
    path: '/branch/:id',
    name: 'Branch',
    component: () => import('../views/branch/Branch.vue')
  }, {
    path: '/404',
    component: NotFound
  }, {
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // linkExactActiveClass: 'active',
  linkActiveClass: 'active',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 上海甲申速递有限公司`
  }
  next()
})

export default router
